<div class="glippy-table-card">
  <div class="glippy-table-card__title" *ngIf="data.title">{{ data.title }}</div>
  <div class="glippy-table-scroll">
    <table class="glippy-table">
      <thead>
        <tr>
          <th
            *ngFor="let c of data.columns"
            [class.glippy-table__cell--num]="numericColumns.has(c.key)"
          >
            {{ c.label }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of data.rows">
          <td
            *ngFor="let c of data.columns"
            [class.glippy-table__cell--num]="numericColumns.has(c.key)"
          >
            {{ formatCell(row[c.key]) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
